import React, {Component} from 'react';
const $ = require('jquery');
const jzip = require('jzip');
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);

const columns = [
  {
    title: 'รหัสพนักงาน',
    data: 'pin_to'
  },
  {
    title: 'ผู้ขอ',
    data: 'pin_staff'
  },
  {
    title: 'วันที่เดินทาง',
    data: 'pin_date'
  },
  {
    title: 'pin',
    data: 'pin'
  },
  {
    title: 'CR',
    data: 'pin_by'
  },
  {
    title: 'วันที่สร้าง',
    data: 'pin_insert'
  },
  {
    title: '',
    data: 'pin',
    render: function (data, type, row) {
      if (type === 'display') {
        return `<input class="btn btn-primary btn-xs m-1" type="button" id="cc-${data}" value="คัดลอก">`;
      }
      return data;
    }
  }
];

function reloadTableData(items, page) {
  console.log('reload: ' + items.length);
  const table = $(`#${id}`).DataTable();

  table.clear();
  table.rows.add(items);
  table.draw();
  table.page(page).draw('page');
}

class TablePin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onUpdate: () => {}
    };
  }

  componentDidMount() {
    var table = $(`#${id}`).DataTable({
      data: this.props.items,
      columns,
      searching: true,
      order: [[5, 'desc']],
      paging: true,
      ordering: true,
      autoWidth: true,
      // scrollX: true,
      responsive: true
    });

    table.on('page', (event) => {
      var info = table.page.info();
      console.log(info.page);
      this.props.onPageChange(info.page);
    });

    $(`#${id} tbody`).on('click', 'input', (event) => {
      var $this = $(event.currentTarget);
      var data = table.row($this.parents('tr')).data();
      this.props.onCopy(`เรียนคุณ ${data.pin_staff}\nสามารถทำการวางแผนย้อนหลังในวันที่ ${data.pin_date} ได้แล้ว\nกรุณากรอกรหัส ${data.pin} เพื่อทำการปลดล็อก\n\nCR manpower`);
      console.log($this.value);
    });
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    // if (nextProps.items.length !== this.props.items.length) {
      reloadTableData(nextProps.items, nextProps.page);
    // }

    return true;
  }

  render() {
    return (
      <div>
        <table
          ref="main"
          className="display responsive nowrap"
          id={id}
          style={{width: '100%'}}
        />
      </div>
    );
  }
}
export default TablePin;
